import { render } from "./CreateDnsZone.vue?vue&type=template&id=83cee8b8&scoped=true"
import script from "./CreateDnsZone.vue?vue&type=script&lang=js"
export * from "./CreateDnsZone.vue?vue&type=script&lang=js"

import "./CreateDnsZone.vue?vue&type=style&index=0&id=83cee8b8&lang=less&scoped=true"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.23.0.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83cee8b8"]])

export default __exports__